import React, {  useEffect, useState } from 'react'
import { Container ,Form} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FaEye } from "react-icons/fa6";
import { format } from 'date-fns';


const ReleasedOrders = () => {
    const [digitizData, setDigitizData]=useState([])
    const [patchData, setPatchData] = useState([])
    const [vectorData, setVectorData] = useState([])
    const [errorD, setErrorD] = useState('')
    const [errorV, setErrorV] = useState('')
    const [errorP, setErrorP] = useState('')
    const [isPatchLoading, setIsPatchLoading] = useState(true)
    const [isDigiLoading, setIsDigiLoading] = useState(true)
    const [isVectorLoading, setIsVectoLoading] = useState(true)


    const [search, setSearch] = useState('');

    const DigitizingRelOrderRecordsApi = `${process.env.REACT_APP_API_URL}/adminDigitRelease/ordersRecords`;
    const VectorRelOrderRecordsApi = `${process.env.REACT_APP_API_URL}/adminVectorRelease/ordersRecords`;
    const PatchRelOrderRecordsApi = `${process.env.REACT_APP_API_URL}/adminPatchRelease/ordersRecords`;



    // GET All Digitiz Orders 24hrs
    useEffect(() => {
        const fetchData = async ()=>{
            try {
                const response = await fetch(DigitizingRelOrderRecordsApi,{
                    method: 'GET',
                    credentials: 'include'
                },)

                if(!response.ok){
                    console.log("!!!!!!!!", response.status)

                    throw new Error(`No Records: ${response.status}`)
                }
                const data = await response.json();
                setDigitizData(data)
                setIsDigiLoading(false)
            } catch (error) {
                setErrorD(error ||"Error in catch" )
                setIsDigiLoading(false)
            }
        }
        fetchData();
    }, [DigitizingRelOrderRecordsApi])

    // GET All Vector Orders of 24hrs
    useEffect(() => {
        const fetchData = async () =>{
            try {
                const response = await fetch(VectorRelOrderRecordsApi,{
                    method: 'GET',
                    credentials: 'include'
                })
                if(!response.ok){
                    throw new Error(`No Records: ${response.status}`)
                }
                const data = await response.json();
                setVectorData(data)
                setIsVectoLoading(false)
                
            } catch (error) {
                setErrorV(error || 'Error in catch')
                setIsVectoLoading(false)
            }
            
        }
        fetchData();
    }, [VectorRelOrderRecordsApi])

    //GET All Patch Orders of 24hrs
    useEffect(()=>{
        const fetchData = async ()=>{
            try {
                const response = await fetch(PatchRelOrderRecordsApi,{
                    method:'GET',
                    credentials:'include'
                })
    
                if(!response.ok){
                    throw Error(`No Records:${response.status}`)
                }
                const data = await response.json();
                setPatchData(data)
                setIsPatchLoading(false)   
            } catch (error) {
                setErrorP(error || 'Error in catch')
                setIsPatchLoading(false)
            }
        }
        fetchData();
    },[PatchRelOrderRecordsApi])

    const filteredPatchData = patchData.filter(item =>
        (item.designName || '').toLowerCase().includes(search.toLowerCase())
        || (item.orderId || '').toLowerCase().includes(search.toLowerCase())
      );

      const filteredDigiData = digitizData.filter(item =>
        (item.designName || '').toLowerCase().includes(search.toLowerCase())
        || (item.orderId || '').toLowerCase().includes(search.toLowerCase())
      );

      const filteredVectorData = vectorData.filter(item =>
        (item.designName || '').toLowerCase().includes(search.toLowerCase())
        || (item.orderId || '').toLowerCase().includes(search.toLowerCase())
      );
console.log('!!!@@@',filteredDigiData,digitizData)
    
  return (
      <>
          <Container>

          {/* /////////////////Digitizing Orders///////////////////// */}
          <table className="table table-bordered text-center my-5">

              <thead>
                  <tr >
                      <th colSpan="12" >
                          <h2>Digitizing Released Orders </h2>
                          <div className='float-end'>
                              <label>Search</label>
                              <Form.Control 
                                type="text"
                                placeholder="ID or DesignName"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                          </div>
                      </th>
                  </tr>
                  <tr>
                    <th scope="col">Ser#</th>
                    <th scope="col">Ordered Date</th>
                      <th scope="col">Order Id</th>
                      <th scope="col">PO Number</th>
                      <th scope="col">Coustumer Name</th>
                      <th scope="col">Costumer Email</th>
                      <th scope="col">Design Name</th>
                      <th scope="col">Price</th>
                      <th scope="col">Details</th>
                      <th scope="col">Released Date</th>
                      <th scope="col">Released No.</th>
                  </tr>
              </thead>
              {isDigiLoading ? (
                    <tbody>
        <tr>
          <td colSpan="8">Loading...</td>
        </tr>
      </tbody>
                ) : errorD ? (
                    <tbody>
        <tr>
          <td colSpan="8">Error: {errorD.message}</td>
        </tr>
      </tbody>
                ) : (
              <tbody>
                {filteredDigiData.map((item,index) => (
                    <tr key={item._id} className=' m-0 p-0 text-center'>
                    <td>{index + 1}</td>
                    <td>{item.dateOrdered ? format(new Date(item.dateOrdered), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.orderId}</td>
                    <td >{item.poNumber}</td>
                    <td >{item.costumerName}</td>
                    <td >{item.costumerEmail}</td>
                    <td >{item.designName}</td>
                    <td className=' text-danger'>
                    {item.price === 'paid' ? (
                        <>
                        {item.amount}
                        {(() => {
                            switch (item.currency) {
                            case 'USD':
                                return <span>.$</span>;

                            case 'POUND':
                                return <span>.£</span>;

                            case 'CA$':
                                return <span>.C$</span>;

                            case 'EURO':
                                return <span>.€</span>;

                            default:
                                return null;
                            }
                        })()}
                        </>
                    ) : (
                        item.price
                    )}
                    </td>
                    <td><Link to={`/singlRelDigitOrdDetail/${item.id}`}><FaEye className=' w-100'/></Link></td>
                    <td>{item.releasedDate ? format(new Date(item.releasedDate), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.relOrderId}</td>
            </tr>
            ))}
              </tbody>
              )}
          </table>

          {/* ///////////////////////////Vector Orders/////////////////////// */}
          <table className="table table-bordered text-center my-5">

              <thead>
                  <tr >
                      <th colSpan="11" >
                          <h2>Vector Released Orders </h2>
                          <div className='float-end'>
                              <label>Search</label>
                              <Form.Control 
                                type="text"
                                placeholder="ID or DesignName"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                          </div>
                      </th>
                  </tr>
                  <tr>
                     <th scope="col">Ser#</th>
                     <th scope="col">Ordered Date</th>
                      <th scope="col">Order Id</th>
                      <th scope="col">PO Number</th>
                      <th scope="col">Coustumer Name</th>
                      <th scope="col">Costumer Email</th>
                      <th scope="col">Design Name</th>
                      <th scope="col">Price</th>
                      <th scope="col">Details</th>
                      <th scope="col">Released Date</th>
                      <th scope="col">Released No.</th>
                  </tr>
              </thead>
              {isVectorLoading ? (
                    <tbody>
        <tr>
          <td colSpan="8">Loading...</td>
        </tr>
      </tbody>
                ) : errorV ? (
                    <tbody>
        <tr>
          <td colSpan="8">Error: {errorV.message}</td>
        </tr>
      </tbody>
                ) : (
              <tbody>
                {filteredVectorData.map((item,index) => (
                    <tr key={item._id} className=' m-0 p-0 text-center'>
                    <td>{index + 1}</td>
                    <td>{item.dateOrdered ? format(new Date(item.dateOrdered), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.orderId}</td>
                    <td >{item.poNumber}</td>
                    <td >{item.costumerName}</td>
                    <td >{item.costumerEmail}</td>
                    <td >{item.designName}</td>
                    <td className=' text-danger'>
                    {item.price === 'paid' ? (
                        <>
                        {item.amount}
                        {(() => {
                            switch (item.currency) {
                            case 'USD':
                                return <span>.$</span>;

                            case 'POUND':
                                return <span>.£</span>;

                            case 'CA$':
                                return <span>.C$</span>;

                            case 'EURO':
                                return <span>.€</span>;

                            default:
                                return null;
                            }
                        })()}
                        </>
                    ) : (
                        item.price
                    )}
                    </td>
                    <td><Link to={`/singlRelVectorOrdDetail/${item.id}`}><FaEye className=' w-100'/></Link></td>
                    <td>{item.releasedDate ? format(new Date(item.releasedDate), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.relOrderId}</td>
            </tr>
            ))}
              </tbody>
              )}
          </table>

          {/* //////////////////////Patch Orders//////////////////// */}
          <table className="table table-bordered text-center my-5">

              <thead>
                  <tr >
                      <th colSpan="11" >
                          <h2>Patch Released Orders </h2>
                          <div className='float-end'>
                              <label>Search</label>
                              <Form.Control 
                                type="text"
                                placeholder="ID or DesignName"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                          </div>
                      </th>
                  </tr>
                  <tr>
                     <th scope="col">Ser#</th>
                     <th scope="col">Ordered Date</th>
                      <th scope="col">Order Id</th>
                      <th scope="col">PO Number</th>
                      <th scope="col">Coustumer Name</th>
                      <th scope="col">Costumer Email</th>
                      <th scope="col">Design Name</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Price</th>
                      <th scope="col">Details</th>
                      <th scope="col">Released Date</th>
                      <th scope="col">Released No.</th>
                  </tr>
              </thead>
              {isPatchLoading ? (
                    <tbody>
        <tr>
          <td colSpan="8">Loading...</td>
        </tr>
      </tbody>
                ) : errorP ? (
                    <tbody>
        <tr>
          <td colSpan="8">Error: {errorP.message}</td>
        </tr>
      </tbody>
                ) : (
              <tbody>
                {filteredPatchData.map((item,index) => (
                    <tr key={item._id} className=' m-0 p-0 text-center'>
                    <td>{index + 1}</td>
                    <td>{item.dateOrdered ? format(new Date(item.dateOrdered), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.orderId}</td>
                    <td >{item.poNumber}</td>
                    <td >{item.costumerName}</td>
                    <td >{item.costumerEmail}</td>
                    <td >{item.designName}</td>
                    <td >{item.quantity}</td>
                    <td className=' text-danger'>
                    {item.price === 'paid' ? (
                        <>
                        {item.amount}
                        {(() => {
                            switch (item.currency) {
                            case 'USD':
                                return <span>.$</span>;

                            case 'POUND':
                                return <span>.£</span>;

                            case 'CA$':
                                return <span>.C$</span>;

                            case 'EURO':
                                return <span>.€</span>;

                            default:
                                return null;
                            }
                        })()}
                        </>
                    ) : (
                        item.price
                    )}
                    </td>
                    <td><Link to={`/singlRelPatchOrdDetail/${item.id}`}><FaEye className=' w-100'/></Link></td>
                    <td>{item.releasedDate ? format(new Date(item.releasedDate), 'MM/dd/yyyy h:mm a') : null}</td>
                    <td >{item.relOrderId}</td>
            </tr>
            ))}
              </tbody>
              )}
          </table>
          
          
          </Container>
      </>
  )
}

export default ReleasedOrders
